export class AlertDataTypes {
	public static MODAL: string = 'modal';
	public static ACCEPT: string = 'accept';
	public static LOGIN: string = 'login';
}